// extracted by mini-css-extract-plugin
export default {"fullScreenPage":"yl1-cr9WEv33xjb75KXVow=="};